export function initPage() {
  /**
   * Lazy loading fallback
   */
  if ('loading' in HTMLImageElement.prototype) {
    const images = document.querySelectorAll('img[loading="lazy"]');

    images.forEach((img) => {
      // If you rely on sizes="auto", emulate it:
      if ((img.dataset.sizes || '').toLowerCase() === 'auto') {
        const w = Math.ceil(img.getBoundingClientRect().width);
        if (w > 0) img.sizes = `${w}px`;
      } else if (img.dataset.sizes) {
        img.sizes = img.dataset.sizes;
      }

      if (img.dataset.src && img.dataset.src !== 'undefined')
        img.src = img.dataset.src;
      if (img.dataset.srcset && img.dataset.srcset !== 'undefined')
        img.srcset = img.dataset.srcset;

      img.classList.remove('blur-up', 'lazyload');
    });
  } else {
    // Dynamically import the LazySizes library
    const script = document.createElement('script');
    script.src =
      'https://cdnjs.cloudflare.com/ajax/libs/lazysizes/5.1.2/lazysizes.min.js';
    document.body.appendChild(script);
  }
}
